// Map

export const MAP_SEARCHING = 'MAP_SEARCHING'

export const MAP_RESULT = 'MAP_RESULT'

export const GEOPASSAGES_RESULT = 'GEOPASSAGES_RESULT'

export const MAP_CLEAR = 'MAP_CLEAR'

export const MAP_MESSAGE = 'MAP_MESSAGE'

export const CLEAR_MAP_MESSAGE = 'CLEAR_MAP_MESSAGE'

// Rondes

export const RONDES_RESULT = 'RONDES_RESULT'

export const RONDE_RESULT = 'RONDE_RESULT'

export const ADRESSES_RESULT = 'ADRESSES_RESULT'

export const RONDES_SEARCHING = 'RONDES_SEARCHING'

export const CLEAR_RONDE_MESSAGE = 'CLEAR_RONDE_MESSAGE'

export const RONDES_IMPORT_MESSAGE = 'RONDES_IMPORT_MESSAGE'

export const CLEAR_RONDES_IMPORT_MESSAGE = 'CLEAR_RONDES_IMPORT_MESSAGE'

export const SHOW_RONDE_ERROR_MESSAGE = 'SHOW_RONDE_ERROR_MESSAGE'

export const SHOW_RONDE_WARNING_MESSAGE = 'SHOW_RONDE_WARNING_MESSAGE'

// Rondes - modif d'une intervention

export const RONDE_LOADING_FOR_SWITCHING_INTERVENTIONS_POSITIONS = 'RONDE_LOADING_FOR_SWITCHING_INTERVENTIONS_POSITIONS'

export const RONDE_INTERVENTIONS_SWITCHED = 'RONDE_INTERVENTIONS_SWITCHED'

export const SHOW_DETAIL_MODAL_FOR_INTERVENTION = 'SHOW_DETAIL_MODAL_FOR_INTERVENTION'

export const HIDE_DETAIL_MODAL_FOR_INTERVENTION = 'HIDE_DETAIL_MODAL_FOR_INTERVENTION'

export const DETAIL_MODAL_FOR_INTERVENTION_LOADING = 'DETAIL_MODAL_FOR_INTERVENTION_LOADING'

export const DETAIL_MODAL_FOR_INTERVENTION_MESSAGE = 'DETAIL_MODAL_FOR_INTERVENTION_MESSAGE'

export const INTERVENTION_REMOVED = 'INTERVENTION_REMOVED'

export const INTERVENTION_AND_ADRESSE_UPDATED = 'INTERVENTION_AND_ADRESSE_UPDATED'

export const INTERVENTION_UPDATED = 'INTERVENTION_UPDATED'

export const SHOW_DETAIL_MODAL_FOR_DEBUT_FIN_JALON = 'SHOW_DETAIL_MODAL_FOR_DEBUT_FIN_JALON'

export const HIDE_DETAIL_MODAL_FOR_DEBUT_FIN_JALON = 'HIDE_DETAIL_MODAL_FOR_DEBUT_FIN_JALON'

export const DEBUT_FIN_JALON_REMOVED = 'DEBUT_FIN_JALON_REMOVED'

// Ronde - ajout d'une intervention

export const SHOW_MODAL_FOR_AJOUT_INTERVENTION = 'SHOW_MODAL_FOR_AJOUT_INTERVENTION'

export const HIDE_MODAL_FOR_AJOUT_INTERVENTION = 'HIDE_MODAL_FOR_AJOUT_INTERVENTION'

export const AJOUT_INTERVENTION_MODAL_SEARCHING = 'AJOUT_INTERVENTION_MODAL_SEARCHING'

export const AJOUT_INTERVENTION_MODAL_SEARCH_RESULT = 'AJOUT_INTERVENTION_MODAL_SEARCH_RESULT'

export const AJOUT_INTERVENTION_MODAL_LOADING = 'AJOUT_INTERVENTION_MODAL_LOADING'

export const AJOUT_INTERVENTION_MODAL_MESSAGE = 'AJOUT_INTERVENTION_MODAL_MESSAGE'

// Ronde - update modal

export const SHOW_RONDE_UPDATE_MODAL = 'SHOW_RONDE_UPDATE_MODAL'

export const SHOW_RONDE_IMPORT_MODAL = 'SHOW_RONDE_IMPORT_MODAL'

export const HIDE_RONDE_UPDATE_MODAL = 'HIDE_RONDE_UPDATE_MODAL'

export const UPDATE_RONDE_LOADING = 'UPDATE_RONDE_LOADING'

export const UPDATE_RONDE_FINISHED = 'UPDATE_RONDE_FINISHED'

export const AJOUT_DEBUT_OU_FIN_JALON = 'AJOUT_DEBUT_OU_FIN_JALON'

// Ronde - create modal

export const SHOW_RONDE_CREATE_MODAL = 'SHOW_RONDE_CREATE_MODAL'

export const HIDE_RONDE_CREATE_MODAL = 'HIDE_RONDE_CREATE_MODAL'

export const CREATE_RONDE_LOADING = 'CREATE_RONDE_LOADING'

export const CREATE_RONDE_FINISHED = 'CREATE_RONDE_FINISHED'

// Login

export const LOGIN_LOADING = 'LOGIN_LOADING'

export const LOGIN_MESSAGE = 'LOGIN_MESSAGE'

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'

export const CLEAR_LOGIN_MESSAGE = 'CLEAR_LOGIN_MESSAGE'

export const LOGOUT = 'LOGOUT'

// Login

export const RESET_PASSWORD_MESSAGE = 'RESET_PASSWORD_MESSAGE'
export const CLEAR_RESET_PASSWORD_MESSAGE = 'CLEAR_RESET_PASSWORD_MESSAGE'

// Agents

export const AGENTS_RESULT = 'AGENTS_RESULT'

export const AGENTS_LIST_RESULT = 'AGENTS_LIST_RESULT'

export const ADD_AGENT = 'ADD_AGENT'

export const CREATE_AGENT = 'CREATE_AGENT'

export const UPDATE_AGENT = 'UPDATE_AGENT'

export const AGENT_MESSAGE = 'AGENT_MESSAGE'

export const AGENTS_CHANGE_PASSWORD = 'AGENTS_CHANGE_PASSWORD'

export const CLEAR_AGENTS_MESSAGE = 'CLEAR_AGENTS_MESSAGE'

export const AGENT_DATA_RONDES_RESULT = 'AGENT_DATA_RONDES_RESULT'

export const AGENT_DATA_TOURNEES_RESULT = 'AGENT_DATA_TOURNEES_RESULT'

export const DISPLAY_AGENT_CREATE_BOX = 'DISPLAY_AGENT_CREATE_BOX'

export const HIDE_AGENT_CREATE_BOX = 'HIDE_AGENT_CREATE_BOX'

// Agents - change password modal

export const SHOW_AGENT_PASSWORD_CHANGE_MODAL = 'SHOW_AGENT_PASSWORD_CHANGE_MODAL'

export const HIDE_AGENT_PASSWORD_CHANGE_MODAL = 'HIDE_AGENT_PASSWORD_CHANGE_MODAL'

export const PASSWORD_CHANGE_LOADING = 'PASSWORD_CHANGE_LOADING'

export const PASSWORD_CHANGE_FINISHED = 'PASSWORD_CHANGE_FINISHED'

// Administrators

export const ADMINS_RESULT = 'ADMINS_RESULT'

export const ADMINS_CHANGE_PASSWORD = 'ADMINS_CHANGE_PASSWORD'

export const ADMINISTRATOR_MESSAGE = 'ADMINISTRATOR_MESSAGE'

export const ADD_ADMINISTRATOR = 'ADD_ADMINISTRATOR'

export const CREATE_ADMINISTRATOR = 'CREATE_ADMINISTRATOR'

export const UPDATE_ADMINISTRATOR = 'UPDATE_ADMINISTRATOR'

export const CLEAR_ALL_ADMINISTRATORS = 'CLEAR_ALL_ADMINISTRATORS'

export const CLEAR_ADMINISTRATORS_MESSAGE = 'CLEAR_ADMINISTRATORS_MESSAGE'

export const DISPLAY_ADMINISTRATOR_CREATE_BOX = 'DISPLAY_ADMINISTRATOR_CREATE_BOX'

export const HIDE_ADMINISTRATOR_CREATE_BOX = 'HIDE_ADMINISTRATOR_CREATE_BOX'

// Administrators - change password modal

export const SHOW_ADMINISTRATOR_PASSWORD_CHANGE_MODAL = 'SHOW_ADMINISTRATOR_PASSWORD_CHANGE_MODAL'

export const HIDE_ADMINISTRATOR_PASSWORD_CHANGE_MODAL = 'HIDE_ADMINISTRATOR_PASSWORD_CHANGE_MODAL'

export const ADMINISTRATOR_PASSWORD_CHANGE_LOADING = 'ADMINISTRATOR_PASSWORD_CHANGE_LOADING'

export const ADMINISTRATOR_PASSWORD_CHANGE_FINISHED = 'ADMINISTRATOR_PASSWORD_CHANGE_FINISHED'

// Anomalies

export const ANOMALIES_FILTER_RESULT = 'ANOMALIES_FILTER_RESULT'

export const ANOMALIES_REPORTING_RESULT = 'ANOMALIES_REPORTING_RESULT'

export const ANOMALIE_FETCH_IMAGE = 'ANOMALIE_FETCH_IMAGE'

// PROFIL DIV

export const SHOW_PROFIL_DIV = 'SHOW_PROFIL_DIV'

// REPORTING

export const REPORTING_CLEAR_FILTERS = 'REPORTING_CLEAR_FILTERS'

export const SHOW_REPORTING_LOADING = 'SHOW_REPORTING_LOADING'

export const HIDE_REPORTING_LOADING = 'HIDE_REPORTING_LOADING'

export const REPORTING_MESSAGE = 'REPORTING_MESSAGE'

export const REPORTING_RESULT = 'REPORTING_RESULT'

export const REPORTING_DATA_RESULT = 'REPORTING_DATA_RESULT'

export const JALONS_RESULT = 'JALONS_RESULT'



// WEBPACK FOOTER //
// ./src/store/mutations-types.js